import $ from "jquery";
import Isotope from "isotope-layout";
import { debounce } from "@pwalton/js-utils/src/functions";

$(function onActivitiesReady() {
	const $filters = $(".activities-filters");

	const activitiesIndexEl = document.getElementById("activities-index");
	const activeFilters = {};

	$filters
		.find("select, input")
		.on("change", function () {
			if (this.checked === false) {
				return;
			}
			this.dataset.value = this.value;
		})
		.trigger("change");

	const isotopeOptions = {
		itemSelector: "article",
		layoutMode: "fitRows",
		percentPosition: true,
		transitionDuration: 300,
	};

	if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
		isotopeOptions.hiddenStyle = { opacity: 0, visibility: "hidden" };
		isotopeOptions.visibleStyle = { opacity: 1, visibility: "visible" };
	}

	const isotope = new Isotope(activitiesIndexEl, isotopeOptions);

	function reconcileFilters() {
		let filter = "";
		for (const key in activeFilters) {
			if (!Object.hasOwnProperty.call(activeFilters, key)) {
				continue;
			}
			const value = activeFilters[key];
			if (value) {
				filter += `.${key}-${value}`;
			}
		}
		isotope.arrange({ filter });
	}

	$filters
		.find("select[data-filters]")
		.on("change", function () {
			activeFilters[this.dataset.filters] = this.value;
			reconcileFilters();
		})
		.trigger("change");
	$filters
		.find('input[type="radio"][data-filters]')
		.on("change", function () {
			if (!this.checked) {
				return;
			}
			activeFilters[this.dataset.filters] = this.value;
			reconcileFilters();
		})
		.trigger("change");

	$(window)
		.on(
			"resize",
			debounce(function () {
				const els = $(isotope.getItemElements());
				let minHeight = 0;
				els
					.css({ minHeight: "0px" })
					.each((_i, el) => {
						minHeight = Math.max(minHeight, el.offsetHeight);
					})
					.css({ minHeight: `${minHeight}px` });
				isotope.layout();
			}, 300)
		)
		.on(
			"resize",
			debounce(() => isotope.arrange(), 1000)
		)
		.trigger("resize");
});
